import { ContentBlockRecord } from "./ContentBlocksPage.utils";
import { makeCygnusApiCall } from "../../../api/api";

/**
 * Fetches content blocks.
 * - If contentBlockId is provided (non-zero), fetches a single block.
 * - If not provided, fetches all blocks.
 */
export const fetchContentBlocks = async (
  contentBlockId?: number | string
) => {

  // Build URL strictly based on whether ID is provided
  const url =
    contentBlockId
      ? `/engagement-letter/content_blocks/?ContentBlockId=${contentBlockId}`
      : `/engagement-letter/content_blocks/`;

  const response = await makeCygnusApiCall({
    type: "GET",
    url,
    forMDM: true,
    isblob: false,
    show_message: false,
  });

  if (response.success) return response.data;

  throw new Error("Failed to load content block");
};


/**
 * Save a content block.
 * @returns Promise resolving to success status.
 */
export const saveContentBlockDetails = async ({
  ContentBlockId,
  BlockName,
  BlockData,
  FilePath,
  Status,
  Active,
  Instructions,
  Operation = "save"
}: ContentBlockRecord): Promise<boolean> => {

  const body = {
    ContentBlockId: ContentBlockId,
    BlockName: BlockName,
    BlockData: BlockData,
    FilePath: FilePath,
    Status: Status,
    Active: Active,
    Instructions: Instructions
  };

  const response = await makeCygnusApiCall({
    type: "POST",
    payload: body,
    url: "/engagement-letter/content_blocks/",
    show_message: true,
    customized_success_message: `Content block ${Operation}d successfully!`,
    customized_failure_message:
      `Unable to ${Operation} content block, please try again. If the problem persists, please contact support and attach a screenshot.`,
    customized_error_message:
      `An error occurred while ${Operation}ing content block, please contact support and attach a screenshot.`,
    isblob: false,
    forMDM: true,
  });

  return response.success;
};
